import Menu from "./Menu";
import MenuItem from "./MenuItem";
import MenuItems from "./MenuItems";
import MenuTrigger from "./MenuTrigger";

export { useMenuContext } from "./MenuContext";

export default Object.assign(Menu, {
  Trigger: MenuTrigger,
  Items: MenuItems,
  Item: MenuItem,
});
